import axios from "axios";
import { Edit, Trash } from "iconsax-react";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DeleteModal from "../../components/delete_modal.jsx";
import ProgressSpinner from "../../components/progress_spinner.jsx";
import Table from "../../components/table.jsx";
import { commonConfigs, urls } from "../../../../config.js";
import UpdateNavigationAccessModal from "../navigation/components/update_navigation_access_modal.jsx";
import CreateNavigationAccessModal from "../navigation/components/create_navigation_access_modal.jsx"
import beveatApiStaging from "../../../api/staging_beveat_api.js";
import beveatApiProduction from "../../../api/production_beveat_api.js";

const NavigationAccessLayout = () => {
  const [load, setLoad] = useState(false);
  const [isCreateModal, setCreateModal] = useState(false);
  const [isUpdateModal, setUpdateModal] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [accessData, setAccessData] = useState([]);
  const [rowToEdit, setRowToEdit] = useState();
  const [isMobile, setIsMobile] = useState(false);

  let getAllAccessPagesUrl = ``;
  let deleteAccessPagesUrl = ``;
  let apiHeaders;
  let apiInstance;

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (process.env.REACT_APP_ENV === "staging") {
    getAllAccessPagesUrl =
      urls.baseUrl +
      commonConfigs.apiUrls.getAllAccessPages();
    deleteAccessPagesUrl =
      urls.baseUrl
    apiHeaders = commonConfigs.apiHeader;
    apiInstance = beveatApiStaging;
  } else {
    getAllAccessPagesUrl =
      urls.prodUrl +
      commonConfigs.apiUrls.getAllAccessPages();
    deleteAccessPagesUrl =
      urls.prodUrl
    apiHeaders = commonConfigs.prodApiHeader;
    apiInstance = beveatApiProduction;
  }

  async function getAccessPages() {
    await apiInstance
      .get(getAllAccessPagesUrl, { headers: apiHeaders })
      .then((res) => {
        // console.log(res.data.result.data);
        setAccessData(res.data.result.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getAccessPages();
  }, []);

  const columns = useMemo(() => [
    // {
    //   Header: "Access Id",
    //   accessor: "access_id",
    // },
    {
      Header: "Web Portal Sidebar",
      accessor: "access_name",
      Cell: ({ value }) => (
        <div
          className="text-sm text-gray-900"
          style={{
            fontSize: isMobile ? "14px" : undefined,
            lineHeight: isMobile ? "1.4" : undefined,
            wordBreak: isMobile ? "break-word" : undefined
          }}
        >
          {value}
        </div>
      ),
    },
    {
      Header: "Web Portal Sidebar Dropdown",
      accessor: "access_name_option",
      Cell: ({ row }) => {
        return (
          <div
            className="text-sm text-gray-900"
            style={{
              fontSize: isMobile ? "14px" : undefined,
              lineHeight: isMobile ? "1.4" : undefined,
              wordBreak: isMobile ? "break-word" : undefined
            }}
          >
            {row.original.access_name_option
              ? row.original.access_name_option
              : "-"}
          </div>
        );
      },
    },
    {
      id: "edit",
      Cell: ({ row }) => {
        return (
          <div
            className="text-gray-900 flex justify-end space-x-3"
            style={{ paddingRight: isMobile ? "8px" : "15px" }}
          >
            <button
              type="button"
              onClick={() => {
                setUpdateModal(true);
                setRowToEdit(row.original);
              }}
              style={{
                minHeight: isMobile ? "44px" : undefined,
                minWidth: isMobile ? "44px" : undefined,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: isMobile ? "8px" : undefined
              }}
            >
              <Edit
                aria-hidden="true"
                className={`${isMobile ? 'w-5 h-5' : 'w-6 h-6'}`}
              />
            </button>
            <button
              type="button"
              onClick={() => {
                setDeleteModal(true);
                setRowToEdit(row.original);
              }}
              style={{
                minHeight: isMobile ? "44px" : undefined,
                minWidth: isMobile ? "44px" : undefined,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: isMobile ? "8px" : undefined
              }}
            >
              <Trash
                aria-hidden="true"
                className={`${isMobile ? 'w-5 h-5' : 'w-6 h-6'}`}
              />
            </button>
          </div>
        );
      },
    },
  ]);

  if (!load) {
    return (
      <div className="w-full bg-gray-100 min-h-screen">
        {/* Add mobile-specific CSS */}
        {isMobile && (
          <style>
            {`
              @media (max-width: 768px) {
                .table-container .flex.justify-between.items-center {
                  flex-direction: column !important;
                  align-items: center !important;
                  gap: 12px !important;
                }
                .table-container .flex.justify-between.items-center > div:first-child {
                  width: 100% !important;
                  text-align: center !important;
                }
                .table-container .flex.justify-between.items-center > div:last-child {
                  width: 100% !important;
                }
                .table-container h2 {
                  margin-bottom: 0 !important;
                  white-space: normal !important;
                  word-break: break-word !important;
                  text-align: center !important;
                }
              }
            `}
          </style>
        )}

        <div className={`${isMobile ? 'p-4' : 'p-6'}`}>
          {/* Header Section */}
          <div className={`${isMobile ? 'mb-6 mt-2' : 'flex justify-end items-center mb-12 mt-2'}`}>
            {/* Mobile Title */}
            {isMobile && (
              <div className="text-center mb-4">
                <h2
                  className="font-bold text-gray-900"
                  style={{
                    fontSize: "20px",
                    marginBottom: "0",
                    lineHeight: "1.3"
                  }}
                >
                  Navigation Page Access
                </h2>
              </div>
            )}

            {/* Create Button */}
            <div className={isMobile ? 'text-center' : ''}>
              <button
                type="button"
                onClick={() => setCreateModal(true)}
                className="hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 font-bold py-2 px-12 rounded-full"
                style={{
                  fontSize: isMobile ? "16px" : undefined,
                  width: isMobile ? "100%" : undefined,
                  maxWidth: isMobile ? "300px" : undefined
                }}
              >
                Create Navigation Access
              </button>
            </div>
          </div>

          {/* Table Section */}
          {accessData != null ? (
            <div
              className="table-container"
              style={{
                overflowX: isMobile ? "auto" : "visible",
                marginBottom: isMobile ? "20px" : undefined,
                // Add webkit scrolling for smooth mobile scrolling
                WebkitOverflowScrolling: isMobile ? "touch" : undefined
              }}
            >
              <Table
                columns={columns}
                data={accessData}
                title="All Navigation Access"
                filters={columns.map((column) => column.accessor)}
              />
            </div>
          ) : (
            <div className={`${isMobile ? 'w-full h-96' : 'w-screen h-screen'} flex flex-wrap flex-row place-items-center`}>
              <div className="flex place-content-center w-full">
                <div className="text-center">
                  <ProgressSpinner className={`${isMobile ? 'w-12 h-12' : 'w-20 h-20'}`} />
                  {isMobile && (
                    <p className="mt-4 text-gray-600 text-sm">
                      Loading navigation page access...
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Modals */}
          {isCreateModal && (
            <CreateNavigationAccessModal
              setOpenModal={setCreateModal}
              refreshData={getAccessPages}
            />
          )}
          {isUpdateModal && (
            <UpdateNavigationAccessModal
              setOpenModal={setUpdateModal}
              load={setLoad}
              row={rowToEdit}
            />
          )}
          {isDeleteModal && (
            <DeleteModal
              setDeleteModal={setDeleteModal}
              load={getAccessPages}
              url={deleteAccessPagesUrl + commonConfigs.apiUrls.deleteAccessPage(rowToEdit.access_id)}
            />
          )}
        </div>
      </div>
    );
  }

  // Mobile-friendly loading state
  return (
    <div className="w-full bg-gray-100 min-h-screen">
      <div className="flex items-center justify-center" style={{ minHeight: "50vh" }}>
        <div className="text-center p-8">
          <div className={`animate-spin rounded-full border-4 border-blue-200 border-t-blue-600 mx-auto mb-4 ${isMobile ? 'h-12 w-12' : 'h-16 w-16'
            }`}></div>
          <h3 className={`font-medium text-gray-900 ${isMobile ? 'text-lg' : 'text-xl'}`}>
            Loading Navigation Access
          </h3>
          <p className={`text-gray-600 ${isMobile ? 'text-sm' : 'text-base'}`}>
            Please wait while we fetch the navigation data...
          </p>
        </div>
      </div>
    </div>
  );
};

export default NavigationAccessLayout;